<script>
import { Bar, mixins } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { mapState } from 'vuex';
// import { computed, watch } from 'vue';
// import { mapState } from 'vuex';

const { reactiveData } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveData],
  props: ['data', 'chartType'],
  data() {
    return {
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        plugins: {
          datalabels: {
            color: this.isDarkMode ? '#ffffff' : '#e0e0e0',
            font: {
              weight: 'bold',
              size: 12
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scaleShowValues: true,
        scales: {
         yAxes: [
            {
              stacked: true,
              gridLines: {
                color: this.isDarkMode ? '#ffffff' : '#e0e0e0'
              },
              ticks: {
                beginAtZero: true,
                fontColor: this.isDarkMode ? '#ffffff' : '#000000'
              }
            }
          ],
          xAxes: [
            {
              stacked: true,
              autoSkip: false,
              gridLines: {
                color: this.isDarkMode ? '#ffffff' : '#e0e0e0'
              },
              ticks: {
                beginAtZero: true,
                fontColor: this.isDarkMode ? '#ffffff' : '#000000'
              }
            }
          ]
        }
      }
    };
  },
  computed: {
  ...mapState('darkMode', ['isDarkMode'])
},

  mounted() {
    this.addPlugin(ChartDataLabels);
    this.renderChart(this.chartData, this.options);
  },
  watch: {
     isDarkMode(val) {
    const color = val ? '#ffffff' : '#e0e0e0';

    this.options.scales.xAxes[0].gridLines.color = color;
    this.options.scales.yAxes[0].gridLines.color = color;

    this.renderChart(this.chartData, this.options);
  },
    data(value) {
      this.chartData = {
        ...this.chartData,
        labels: value.map(i => i[this.chartType], 'Total'),

        datasets: [
          {
            label: `Single Order: ${value.reduce((i, j) => i + j.singleOrderCount, 0)}`,
            backgroundColor: 'Black',
            hoverBackgroundColor: 'Black',
            data: value.map(i => i.singleOrderCount)
          },
          {
            label: `Bulk Order: ${value.reduce((i, j) => i + j.bulkOrderCount, 0)}`,
            backgroundColor: 'Orange',
            hoverBackgroundColor: 'Orange',
            data: value.map(i => i.bulkOrderCount)
          },
          {
            label: `Acknowledge Count: ${value.reduce((i, j) => i + j.acknowledgeCount, 0)}`,
            backgroundColor: 'Green',
            hoverBackgroundColor: 'green',
            data: value.map(i => i.acknowledgeCount)
          },
          {
            label: `IVR Order Count: ${value.reduce((i, j) => i + j.ivrOrderCount, 0)}`,
            backgroundColor: 'fuchsia',
            hoverBackgroundColor: 'fuchsia',
            data: value.map(i => i.ivrOrderCount)
          }
        ]
      };
    }
  }
};
</script>

